// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.v-slider-range {
  gap: var(--slider-gap-default);
  grid-template-columns: auto 1fr auto;
  align-items: center;
}

.v-component-container {
  width: var(--slider-width-full);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/wrappers/lib/slider/slider.component.sass"],"names":[],"mappings":"AAAA;EACI,8BAAA;EACA,oCAAA;EACA,mBAAA;AACJ;;AACA;EACI,+BAAA;AAEJ","sourcesContent":[".v-slider-range\n    gap: var(--slider-gap-default)\n    grid-template-columns: auto 1fr auto\n    align-items: center\n\n.v-component-container\n    width: var(--slider-width-full)"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
